import React from 'react';

export default function Loading(){
	return (
		<div className="loading-spinner"><span className="spinner-icon" /></div>
	);
}
